import clsx from "clsx"
import { localizeText } from "src/localization/utils"
import { qualifiesForFreeShipping } from "src/utilities/product"

export type ShippingCostProps = {
  price: number
}

export const ShippingCost = ({ price }: ShippingCostProps) => {
  const T = localizeText(text)
  const shippingIsFree = qualifiesForFreeShipping(price)

  return (
    <div
      className={clsx({
        "text-success font-medium": shippingIsFree,
      })}
    >
      {shippingIsFree ? T.freeShipping : T.plusShipping}
    </div>
  )
}

const de = {
  freeShipping: "kostenloser Versand",
  plusShipping: "zzgl. Versand",
}

const en: typeof de = {
  freeShipping: "free shipping",
  plusShipping: "excl. shipping",
}

const text = { en, de }
